import QueryParams from 'sites/utils/QueryParams';

export default () => {
   // Start Debug mode
   const debug = QueryParams.getParam('debug');
   const inDebugParams = QueryParams.keyInParams('debug');
   let debugNumber = null;
   if(debug && !isNaN(+debug)){
      debugNumber = Number(debug);
   }
   if(debug){
      QueryParams.removeQueryParam('debug');
   }
   if((debugNumber && debugNumber > 0) || debugNumber === 0){
      localStorage.setItem('X_CRETRIX_POD', debug);
   }
   if((inDebugParams && !debug) || (debugNumber && debugNumber < 0) || (debug && isNaN(+debug))){
      localStorage.removeItem('X_CRETRIX_POD');
   }
   // End Debug mode
};
